// Cents→USD formatter owned by the RecoveryAI Activation surface (WP7).
//
// Intentionally NOT imported from Overview/format.ts: that module's `displayCurrency`
// is a `$XX.XX` MASK, and the whole `Overview/` directory (including `format.ts`) is
// being deleted by the sibling wave-5 Looker-pivot plan. The Activation surface shows
// REAL dollar values ($250 credit, $0.25/$2.25 per-event rates), so it owns its own
// formatter rather than depending on a doomed/masked module.
interface FormatCentsUsdOptions {
  // When true, render two-decimal precision (e.g. "$0.25"); otherwise whole dollars
  // (e.g. "$250"). Defaults to whole dollars.
  cents?: boolean
}

export const formatCentsUsd = (
  cents: number,
  opts?: FormatCentsUsdOptions
): string =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: opts?.cents ? 2 : 0,
    maximumFractionDigits: opts?.cents ? 2 : 0,
  })
